<template>
  <div
    ref="legoDropdown"
    class="lego-dropdown lego-input"
    :class="dropdownClass"
    :style="[dropdownWidth, dropdownHeight]"
    v-dropdown-click-outside="toggleItemOuter"
  >
    <div
      class="lego-dropdown__title"
      :class="{ 'lego-dropdown--focused': isFocused }"
      :style="customTitleStyle"
      :tabindex="autoComplete || disabled ? -1 : 0"
      style="padding: 0"
    >
      <lego-text-field
        :width="400"
        v-model="searchText"
        :searchable="true"
        :border="false"
        @enter="search"
        @click-icon="search"
        @input="search"
      />
    </div>
    <lego-dropdown-menu
      :items="items"
      :isItemShowing="isItemShowing"
      :autoComplete="autoComplete"
      :autoCompleteText="autoCompleteText"
      :autoCompletePlaceholder="autoCompletePlaceholder"
      :width="itemWidth"
      :itemMaxHeight="itemMaxHeight"
      :filteredItemList="filteredItemList"
      :itemValue="itemValue"
      :itemText="itemText"
      :selectedItem="selItem"
      :focusedItemIndex="focusedItemIndex"
      :focusedDepthIndex="focusedDepthIndex"
      :appendToBody="appendToBody"
      :menuDirection="menuDirection"
      :small="sm || small"
      :shadow="menuShadow"
      :customButtonText="customButtonText"
      :noDataText="noDataText"
      :groups="groups"
      :groupSort="groupSort"
      parent="legoDropdown"
      @click="clickItem"
      @close="toggleItemOuter"
      @customButtonClick="customButtonClick"
      @changeAutoCompleteText="onInput"
    />
    <div
      v-if="messageShow"
      class="lego-dropdown__message lego-validator__message"
      :class="messageClass"
    >
      <!--glue
      -->
      {{ messageShow }}
      <!--glue
      -->
    </div>
  </div>
</template>
<script>
import legoDropdownMenu from './legoDropdownMenu';
import i18nMixin from '@/mixins/i18n.mixin.js';

const DEFAULT_ITEM_VALUE = 'value';

export default {
  mixins: [i18nMixin],
  components: {
    legoDropdownMenu
  },
  props: {
    readOnly: {
      type: Boolean,
      default: false
    },
    // 선택 옵션 기본 추가. 해당 선택 클릭 시 return value는 ''.
    select: {
      type: Boolean,
      default: false
    },
    borderLess: {
      type: Boolean,
      default: false
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    menuDirection: {
      type: String,
      default: 'left'
    },
    titleStyle: {
      type: Object,
      default: () => {}
    },
    titleActiveStyle: {
      type: Object,
      default: () => {}
    },
    menuShadow: {
      type: Boolean,
      default: false
    },
    itemMaxHeight: {
      type: [Number, String],
      default: 272
    },
    customButtonText: {
      type: String,
      default: ''
    },
    noDataText: {
      type: String,
      default: ''
    },
    autoCompletePlaceholder: {
      type: String,
      default: ''
    },
    groups: {
      type: Array,
      default: () => []
    },
    groupSort: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    items() {
      this.setDefault();
    }
  },
  data() {
    return {
      searchText: '',
      default: {
        size: 'medium',
        placeholder: this.t('label.notSelect')
      }
    };
  },
  mounted() {
    this.setDefault();
  },
  computed: {
    dropdownClass() {
      return {
        'lego-dropdown--open': this.isItemShowing,
        'lego-dropdown--readonly': this.readOnly,
        'lego-dropdown--disabled': this.disabled,
        'lego-dropdown--medium': this.$_size === 'medium',
        'lego-dropdown--small': this.$_size === 'small',
        'lego-dropdown--up': this.up,
        'lego-dropdown--borderless': this.borderLess,
        'lego-validator--error': this.hasError === true,
        'lego-validator--valid': this.showValid && this.hasError === false,
        'lego-validator--shake': this.shake
      };
    },
    customTitleStyle() {
      if (this.isItemShowing || this.isFocused) {
        return this.titleActiveStyle;
      } else {
        return this.titleStyle;
      }
    }
  },
  methods: {
    search() {
      if (this.tmpNoSearchText && this.tmpNoSearchText == this.searchText) {
        //마우스로 선택한 경우에 다시 search돼는 현상을 수정함
        return false;
      } else if (this.tmpNoSearchText != this.searchText) {
        this.tmpNoSearchText = null;
      }
      this.$emit('search', this.searchText);
    },
    setSearchText(searchText) {
      this.tmpNoSearchText = searchText;
      this.searchText = searchText;
    },
    open() {
      //console.log('openopen');
      this.isFocused = true;
      this.isItemShowing = false;
      this.toggleItem();
    },
    toggleItem() {
      this.isItemShowing = !this.isItemShowing;
      if (this.autoComplete) {
        this.autoCompleteText = '';
        this.onFilter(this.autoCompleteText);
      }

      this.$emit('onToggle', 'toggle');
    },
    getText(item) {
      if (!item)
        return this.autoComplete ? this.placeholder : this.placeholder || this.default.placeholder;
      let itemText = '';
      if (typeof this.itemText === 'function') {
        itemText = this.itemText(item);
      } else {
        itemText = item[this.itemText];
      }
      if (itemText === undefined || itemText === null) {
        return item;
      } else {
        return itemText;
      }
    },
    setDefault() {
      if (this.items && this.items.length > 0) {
        if (
          this.select &&
          this.items[0][
            this.inputValue || (this.itemValue !== 'object' && this.itemValue) || DEFAULT_ITEM_VALUE
          ] !== ''
        ) {
          const selectObject = {};

          selectObject[this.itemText] = this.$msg('domain.please-select', '-- Select --');

          selectObject[
            this.inputValue || (this.itemValue !== 'object' && this.itemValue) || DEFAULT_ITEM_VALUE
          ] = '';
          this.items.unshift(selectObject);
        }
      }
    },
    customButtonClick(button) {
      this.$emit('customButtonClick', button);
    },
    onInput(value) {
      this.autoCompleteText = value;
      this.onFilter(value);
    }
  }
};
</script>
<style lang="scss" scoped>
.lego-dropdown {
  &__title {
    border-radius: 2px;

    .lego-dropdown__selected {
      width: calc(100% - 24px);

      span {
        display: inline-block;
        @include ellipsis;
      }

      &.placeholder {
        color: $color--ui06;
      }
    }
  }

  &__title-icon {
    .lego-dropdown__icon {
      font-size: 12px;
    }
  }

  .lego-dropdown__title {
    &:focus {
      border: $lego-dropdown__title__border;
    }

    &:hover {
      border-color: $lego-dropdown__title__border--focus;
    }
  }

  &--borderless {
    width: auto;
    min-width: auto;

    .lego-dropdown__title {
      border: 0 !important;

      .lego-dropdown__selected {
        flex-grow: 1;
      }
    }

    &.lego-dropdown--disabled {
      .lego-dropdown__title {
        background: none !important;
      }
    }
  }

  &--readonly {
    pointer-events: none;
    cursor: default;

    .lego-dropdown__title {
      border: $lego-dropdown__title__border--disabled;
      background-color: $lego-dropdown__title__background-color--readonly;
    }
  }

  &--small {
    min-width: $lego-dropdown__min-width--small;

    .lego-dropdown__title-icon {
      .lego-dropdown__icon {
        font-size: 10px;
      }
    }
  }
}
</style>
